import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, Typography } from '@material-ui/core';
import PublishIcon from '@material-ui/icons/Publish';

const useStyles = makeStyles((theme) => ({
  uploadArea: {
    border: '2px dashed #e0e0e0',
    borderRadius: theme.spacing(1),
    padding: theme.spacing(3),
    textAlign: 'center',
    backgroundColor: '#fafafa',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#3f51b5',
      backgroundColor: '#f8f9fa',
    },
  },
  uploadAreaActive: {
    borderColor: '#3f51b5 !important',
    backgroundColor: '#e8eaf6 !important',
  },
  uploadText: {
    fontSize: '14px',
    color: '#666',
    marginBottom: theme.spacing(1),
  },
  uploadButton: {
    backgroundColor: '#3f51b5',
    color: 'white',
    textTransform: 'none',
    padding: theme.spacing(1, 2),
    fontSize: '13px',
    '&:hover': { backgroundColor: '#303f9f' },
  },
  hiddenInput: {
    display: 'none',
  },
  fileName: {
    fontSize: '13px',
    color: '#333',
    marginTop: theme.spacing(1),
    fontWeight: 500,
  },
}));

const CsvUpload = ({ inputId, file, parsedCount, onFileProcessed }) => {
  const classes = useStyles();
  const [dragActive, setDragActive] = useState(false);

  const processFile = (f) => {
    if (!f) return;
    if (f.type !== 'text/csv' && !f.name.endsWith('.csv')) {
      onFileProcessed(null, [], 'Please upload a CSV file.');
      return;
    }
    const reader = new FileReader();
    reader.onload = (e) => {
      const isHeaderRow = (id) => {
        const t = id.toLowerCase().replace(/\s+/g, '');
        return t === 'option_id' || t === 'optionid';
      };
      const ids = e.target.result
        .split(/[\r\n,]+/)
        .map((id) => id.trim())
        .filter((id) => id && !isHeaderRow(id));
      onFileProcessed(f, [...new Set(ids)]);
    };
    reader.readAsText(f);
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'dragenter' || e.type === 'dragover') setDragActive(true);
    else if (e.type === 'dragleave') setDragActive(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files?.[0]) processFile(e.dataTransfer.files[0]);
  };

  return (
    <Box
      className={`${classes.uploadArea} ${dragActive ? classes.uploadAreaActive : ''}`}
      onDragEnter={handleDrag}
      onDragLeave={handleDrag}
      onDragOver={handleDrag}
      onDrop={handleDrop}
    >
      <Typography className={classes.uploadText}>
        {dragActive ? 'Drop your CSV file here' : 'Drag and drop your CSV file here, or click to browse'}
      </Typography>
      <input
        type="file"
        accept=".csv"
        onChange={(e) => { if (e.target.files?.[0]) processFile(e.target.files[0]); }}
        id={inputId}
        className={classes.hiddenInput}
      />
      <label htmlFor={inputId}>
        <Button variant="contained" component="span" className={classes.uploadButton} startIcon={<PublishIcon />} size="small">
          Choose CSV File
        </Button>
      </label>
      {file && (
        <Typography className={classes.fileName}>
          Selected: {file.name} ({parsedCount} option IDs parsed)
        </Typography>
      )}
    </Box>
  );
};

export default CsvUpload;
